/**
 * useAuth — convenience hook wrapping the auth store.
 */

import { useAuthStore } from "@/stores/authStore";
import type { LoginCredentials } from "@/types";

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const login = useAuthStore((s) => s.login);
  const logout = useAuthStore((s) => s.logout);

  return { user, isAuthenticated, login, logout };
}

/**
 * Standalone login helper (for usage outside React).
 */
export async function loginAction(credentials: LoginCredentials) {
  return useAuthStore.getState().login(credentials);
}
